ObjectUtils.define('UIHelpTopicController', UIController, {

  _CURRENT_ANSWER: null,

  didClick: function didClick(container, target) {
    if (DOM.maybeFindParentByClass(target, 'questionContainer')) {
      return this._didClickQuestion(container, target);
    }

    return EventDelegater.FORWARD;
  },

  _didClickQuestion: function _didClickQuestion(container, target) {
    var questionContainer = DOM.findParentByClass(target, 'questionContainer');
    var answerContainer = DOM.findById(DOM.getAttribute(questionContainer, 'answerContainerId'));

    if (!DOM.visible(answerContainer)) {
      if (this._CURRENT_ANSWER) {
        this._CURRENT_ANSWER.slideToggle();
      }
      this._CURRENT_ANSWER = answerContainer;
    } else {
      this._CURRENT_ANSWER = null;
    }

    answerContainer.slideToggle();
    return EventDelegater.STOP;
  }

});
